import Combine from '../../components/Combine/Combine'
import Forget from './Forget'

const ForgetPassword = () => {
  return (
    <Combine>
        <Forget/>
    </Combine>
  )
}

export default ForgetPassword
